import { useCallback } from 'react';
import { FIELD_ERROR_CLASS } from '@wix/form-fields';
export const useScrollToFirstError = ({ form, options, handleStepChange, }) => {
    const scrollToFirstError = useCallback(() => {
        var _a, _b, _c;
        (_c = (_b = (_a = document
            .querySelectorAll(`#form-${form.id} .${FIELD_ERROR_CLASS}`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.scrollIntoView) === null || _c === void 0 ? void 0 : _c.call(_b, {
            block: 'center',
            behavior: 'smooth',
        });
    }, [form]);
    const handleScrollToFirstError = useCallback((errors) => {
        var _a, _b, _c;
        if (Number((_a = form.steps) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            // TODO: Adapt to nested forms
            const field = (_b = form.fields) === null || _b === void 0 ? void 0 : _b.find((_field) => { var _a; return _field.target === ((_a = errors === null || errors === void 0 ? void 0 : errors[0]) === null || _a === void 0 ? void 0 : _a.errorPath); });
            const fieldStep = (_c = form.steps) === null || _c === void 0 ? void 0 : _c.findIndex((step) => {
                var _a, _b, _c;
                const fieldInStep = (_c = (_b = (_a = step.layout) === null || _a === void 0 ? void 0 : _a.large) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.find((layoutField) => layoutField.fieldId === (field === null || field === void 0 ? void 0 : field.id));
                return Boolean(fieldInStep);
            });
            if (typeof fieldStep !== 'undefined' && fieldStep > -1) {
                handleStepChange(fieldStep);
            }
        }
        if (errors.length > 0 && options.enableScrollToFirstError) {
            scrollToFirstError();
        }
    }, [options.enableScrollToFirstError, scrollToFirstError, handleStepChange]);
    return { scrollToFirstError, handleScrollToFirstError };
};
//# sourceMappingURL=use-scroll-to-first-error.js.map